import { AddPaymentMethodModalComponent } from '../modals/add-payment-method-modal/add-payment-method-modal.component';
import { ChangePasswordModalComponent } from '../modals/change-password-modal/change-password-modal.component';
import { EditProfileModalComponent } from '../modals/edit-profile-modal/edit-profile-modal.component';
import { PropertyTypeWelcomeModalComponent } from '../modals/property-type-welcome-modal/property-type-welcome-modal.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EditorModule } from '@tinymce/tinymce-angular';
import { ClooperCommonModule } from '@clooper/common';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClooperModalsModule } from '@clooper/modals';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AddRoomPhotosModalComponent, AddRoomModalComponent, ImgCaptionModalComponent } from '../modals';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PropertyPartnersComponent } from './property-partners/property-partners.component';
import { SocialLoginComponent } from './social-login/social-login.component';
import { LpFilterModalComponent } from './lp-filter-modal/lp-filter-modal.component';
import { ListingComponent } from './listing/listing.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { DashboardPageHeaderComponent } from './dashboard-page-header/dashboard-page-header.component';
import { WebappSideBarComponent } from './webapp-side-bar/webapp-side-bar.component';

import { RatingModule } from 'ngx-bootstrap/rating';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { RestrictionModalComponent } from './restriction-modal/restriction-modal.component';
import { CorporateAccountSearchBoxComponent } from './corporate-account-search-box/corporate-account-search-box.component';
import { CorporateMapComponent } from './corporate-map/corporate-map.component';
import { CorporateMapPopupComponent } from './corporate-map-popup/corporate-map-popup.component';
import { TotalTripsListViewComponent } from '../pages/corporate-account/corporate-account-settings/total-trips-list-view/total-trips-list-view.component';
import { TotalTripsMapViewComponent } from './total-trips-map-view/total-trips-map-view.component';
import { FaqsComponent } from './faqs/faqs.component';
import { FlightsSearchBarComponent } from './flights-search-bar/flights-search-bar.component';
import { MultiDestinationFormComponent } from './flights-search-bar/multi-destination-form/multi-destination-form.component';
import { OneWayFormComponent } from './flights-search-bar/one-way-form/one-way-form.component';
import { RoundTripFormComponent } from './flights-search-bar/round-trip-form/round-trip-form.component';
import { AirportsDeropdownComponent } from './airports-deropdown/airports-deropdown.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FlightDetailComponent } from './flight-detail/flight-detail.component';
import { DashboardPageFooterComponent } from './dashboard-page-footer/dashboard-page-footer.component';
import { SupportBoxComponent } from './support-box/support-box.component';
import { GenericTableComponent } from './generic-table/generic-table.component';
import { NotificationBannerComponent } from './notification-banner/notification-banner.component';

const components: any[] = [
  PropertyTypeWelcomeModalComponent,
  ImgCaptionModalComponent,
  AddRoomModalComponent,
  AddRoomPhotosModalComponent,
  EditProfileModalComponent,
  ChangePasswordModalComponent,
  AddPaymentMethodModalComponent,
  PropertyPartnersComponent,
  SocialLoginComponent,
  LpFilterModalComponent,
  ListingComponent,
  PageHeaderComponent,
  DashboardPageHeaderComponent,
  DashboardPageFooterComponent,
  WebappSideBarComponent,
  RestrictionModalComponent,
  CorporateAccountSearchBoxComponent,
  CorporateMapComponent,
  TotalTripsMapViewComponent,
  CorporateMapPopupComponent,
  FaqsComponent,
  FlightsSearchBarComponent,
  AirportsDeropdownComponent,
  OneWayFormComponent,
  RoundTripFormComponent,
  MultiDestinationFormComponent,
  FlightDetailComponent,
  SupportBoxComponent,
  GenericTableComponent,
  NotificationBannerComponent
]

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    RatingModule,
    EditorModule,
    ClooperCommonModule,
    ClooperModalsModule,
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot()

  ],
  declarations: [
    ...components
  ],
  exports: [
    ...components,
    FontAwesomeModule,
    EditorModule,
    ClooperCommonModule,
    ClooperModalsModule,
    ModalModule,
    TabsModule,
    BsDropdownModule
  ]
})
export class SharedModule { }
